module.exports = __webpack_public_path__ + "static/dcw-2587b325f1d7a83cce234629ced2efca.png";